import React from 'react';
import { Box, Typography, Stack, Button } from '@material-ui/core';
import { CHAT_GPT_DARK } from '../constants';
import { TemporaryChatIcon, NoTrainingIcon, MemoryOffIcon } from './icons';

const TemporaryOnboarding = ({ isDarkMode, onClose, onContinue }) => (
  <Box
    onClick={onClose}
    sx={{
      position: 'absolute',
      inset: 0,
      zIndex: 300,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 2,
      bgcolor: 'rgba(0,0,0,0.5)',
      backdropFilter: 'blur(4px)',
      cursor: 'pointer',
    }}
  >
    <Box
      onClick={(e) => e.stopPropagation()}
      sx={{
        width: '100%',
        maxWidth: 360,
        bgcolor: isDarkMode ? CHAT_GPT_DARK : '#ffffff',
        borderRadius: '24px',
        p: 3,
        pt: 4,
        boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        cursor: 'default',
      }}
    >
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ mb: 3, color: isDarkMode ? 'white' : 'black' }}
      >
        Temporary Chat
      </Typography>

      <Stack spacing={3} sx={{ mb: 4 }}>
        {[
          {
            icon: <TemporaryChatIcon size={24} />,
            title: 'Not in history',
            desc: "Temporary chats won't appear in your history. For safety purposes, we may keep a copy of your chat for up to 30 days.",
          },
          {
            icon: <NoTrainingIcon size={24} />,
            title: 'No model training',
            desc: "Temporary chats won't be used to improve our models.",
          },
          {
            icon: <MemoryOffIcon size={24} />,
            title: 'Memory off',
            desc: "While in a temporary chat, SEFI won't use or update its memory. Custom instructions will still be followed if you have them enabled.",
          },
        ].map((item, idx) => (
          <Stack key={idx} direction="row" spacing={2} alignItems="flex-start">
            <Box sx={{ color: isDarkMode ? 'white' : 'black', mt: 0.5 }}>{item.icon}</Box>
            <Box>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                sx={{
                  color: isDarkMode ? 'white' : 'black',
                  fontSize: '1rem',
                  mb: 0.2,
                }}
              >
                {item.title}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: isDarkMode ? 'rgba(255,255,255,0.6)' : '#666',
                  fontSize: '0.85rem',
                  lineHeight: 1.3,
                  display: 'block',
                }}
              >
                {item.desc}
              </Typography>
            </Box>
          </Stack>
        ))}
      </Stack>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          onClick={onContinue}
          sx={{
            bgcolor: isDarkMode ? 'white' : 'black',
            color: isDarkMode ? 'black' : 'white',
            borderRadius: '25px',
            px: 3,
            py: 0.8,
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: '0.9rem',
            '&:hover': { bgcolor: isDarkMode ? '#eee' : '#333' },
          }}
        >
          Continue
        </Button>
      </Box>
    </Box>
  </Box>
);

export default TemporaryOnboarding;
